export default __webpack_public_path__ + "static/media/4.57c11e53.png";